import React from 'react';
import './App.scss';

import Loader from './Components/Loader'
import Main from './Components/Main';
import * as tooltips from './strings'
import { Navbar, Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Switch from "react-switch";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowCircleLeft, faQuestion, faSpinner, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
library.add(faArrowCircleLeft, faQuestion, faSpinner, faTrashAlt)

const styles = {
  helpIcon: {
    width: '100%',
    height: '100%',
    padding: '5px'

  },
  backBtn: {
    color: 'black',
    width: '25px',
    height: '25px',
    verticalAlign: 'bottom'
  },
  menuText: {
    marginLeft: '15px',
    color: 'black',
    fontWeight: '700',
    fontSize: '18px'
  }
}

function App() {
  const [selectedBook, setSelectedBook] = React.useState(null)
  const [helpIsActive, setHelpIsActive] = React.useState(false)
  const [homeTooltip, setHomeTooltip] = React.useState(false)

  const handlePdfList = (list) => {
    console.log(list)
  }

  const handleHelp = (e) => {
    setHelpIsActive(prevState => (!prevState))
  }

  const handleSelectBook = (book) => e => {
    //console.log('book', book)
    setSelectedBook(book)
  }


  return (<>
    <Navbar bg="warning" variant="warning" style={{ height: '59px' }}>
      {selectedBook &&
        <Nav className="mr-auto">
          <OverlayTrigger
          trigger="focus"
          placement={'right'}
          overlay={<Tooltip id={'helper-tooltip'}>{tooltips.HOME}</Tooltip>}>
            <div>
          <Nav.Link
            onClick={() => {helpIsActive ? setHomeTooltip(true) : selectedBook && setSelectedBook(null)}}>
            <FontAwesomeIcon style={styles.backBtn} icon="arrow-circle-left" /><span style={styles.menuText}> Αρχικό μενού</span>
          </Nav.Link>
          </div>
          </OverlayTrigger>
        </Nav>}
      <Nav className="ml-auto" style={{display: selectedBook ? 'inherit' : 'none'}}>
        <OverlayTrigger
          trigger="hover"
          placement={'left'}
          overlay={<Tooltip id={'helper-tooltip'}>{helpIsActive ? tooltips.ACTIVE_HELP_MODE : tooltips.HELP_MODE}</Tooltip>}>
          <div>
            <Switch
              height={23}
              width={53}
              className={helpIsActive ? 'switch-container active' : 'switch-container'}
              checked={helpIsActive}
              onChange={handleHelp}
              uncheckedIcon={<FontAwesomeIcon icon="question" style={styles.helpIcon} />}
              checkedIcon={<span style={{ backgroundColor: 'transparent' }} />}
            />
          </div>
        </OverlayTrigger>
      </Nav>
    </Navbar>
    {!selectedBook
      ? <Loader handleSelectBook={handleSelectBook} helpIsActive={helpIsActive} />
      : <Main selectedBook={selectedBook} handlePdfList={handlePdfList} toggleHelp={helpIsActive} homeTooltip={homeTooltip} handleHomeTooltip={setHomeTooltip}/>}
  </>);
}

export default App;
